/**
 * Constants for Continue Shopping component
 * Centralized configuration to eliminate magic numbers and improve maintainability
 */

// Data filtering and display thresholds
export const MINIMUM_PRODUCTS_REQUIRED = 8;
export const SEE_ALL_THRESHOLD = 13;
export const MAX_PRODUCTS_DISPLAY = 11;

// Carousel responsive breakpoints
export const CAROUSEL_BREAKPOINTS = {
    MOBILE: 2.2,
    MOBILE_XS: 3.5,
    TABLET_MD: 5.3,
    DESKTOP_LG: 5.6,
} as const;

// IntersectionObserver configuration
export const INTERSECTION_OBSERVER_CONFIG = {
    THRESHOLD: 0.1,
} as const;

// Tracking configuration
export const TRACKING_CONSTANTS = {
    CONTEXT: 'continue_shopping',
    ELEMENT: 'continue_shopping',
    ITEM_LIST_NAME: 'continue_shopping',
    SEE_ALL_CONTENT_ID: 'see_all',
} as const;
